module.exports = __webpack_public_path__ + "static/pipeline-a2d00e924a8dd45b992f528d582c83ea.jpeg";